module.exports = __webpack_public_path__ + "static/media/CV-SaraArellano-EN.795acb34.pdf";